import React from 'react';
import PropTypes from 'prop-types';
import PageBannerView from '../../../../../blocks/PageBanner/View';

const BANNER_TYPES = new Set(['agsusPageBanner', 'agsusSectionBanner']);

// Desde 22/10/2026 o título em cartão creme saiu: página e pasta montadas com
// blocos aparecem com o cabeçalho de página (o mesmo do bloco Banner de
// Página). O que tem tela própria (arquivo, link, evento, pasta em lista) não
// passa por este bloco; notícia e raiz do site ficam com o h1 simples.
export const TIPOS_COM_CABECALHO = new Set(['Document', 'Folder']);
const TITULO_EM_MAIUSCULAS = false; // como os cabeçalhos de página do portal

/**
 * Evita dois H1 quando a composicao editorial ja contem um banner de pagina.
 * A regra depende somente dos blocos recebidos do Plone, nunca da URL.
 */
const TitleBlockView = ({ properties, metadata }) => {
  const content = metadata || properties || {};
  const blocks = Object.values(content.blocks || {});
  const hasEditorialBanner = blocks.some((block) =>
    BANNER_TYPES.has(block?.['@type']),
  );

  if (hasEditorialBanner) return null;

  if (TIPOS_COM_CABECALHO.has(content['@type'])) {
    const mae = content.parent || {};
    // A descrição só aparece onde a página já mostra o bloco de descrição: o
    // texto visível continua o mesmo de antes (o bloco é escondido pelo CSS
    // quando há cabeçalho de página).
    const mostraDescricao = blocks.some(
      (block) => block?.['@type'] === 'description',
    );
    // O envoltório dá o respiro que, nas páginas com o banner como bloco, vem
    // do Espaçador médio posto logo depois dele.
    return (
      <div className="ag-cabecalho-pagina">
        <PageBannerView
          data={{
            eyebrow:
              mae['@type'] && mae['@type'] !== 'Plone Site' ? mae.title : '',
            title: content.title || '',
            lede: mostraDescricao ? content.description || '' : '',
            variant: 'blue',
            align: 'left',
            titleUppercase: TITULO_EM_MAIUSCULAS,
          }}
        />
      </div>
    );
  }

  return <h1 className="documentFirstHeading">{content.title || ''}</h1>;
};

TitleBlockView.propTypes = {
  properties: PropTypes.object,
  metadata: PropTypes.object,
};

export default TitleBlockView;
